import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import initialState from '../helpers/form-helpers/initial-state';
import { addressesFormStateConstants, addressesFormCallbackFunctions } from '../helpers/form-helpers/user-account/address-form-state';
import { addressesFormConstants } from '../../utils/addresses-form-constants';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { isEmpty, deepCopyObject } from '../../utils/obj-utils';
import ConfirmationModal from '../../common/utility/ConfirmationModal';
import { MembershipTypes, getMultilineText } from '../../../../../general/js/utils';
import userService from '../../../../../general/js/user/user-service';

class UserAddressesForm extends Component {
    constructor(props) {
        super(props);
        this.state = initialState.userAddressesFormState;

        const { accountData } = props;
        const copyOfAccountData = deepCopyObject(accountData);
        this.state.accountData = copyOfAccountData;

        this.submitAddressesData = this.submitAddressesData.bind(this);
        this.resetForm = this.resetForm.bind(this);

        this.displayAddressesForm = this.displayAddressesForm.bind(this);
        this.handleShowDisplayAddressForm = this.handleShowDisplayAddressForm.bind(this);

        this.handleShowAddAddressForm = this.handleShowAddAddressForm.bind(this);
        this.handleAddNewAddress = this.handleAddNewAddress.bind(this);

        this.handleShowUpdateAddressForm = this.handleShowUpdateAddressForm.bind(this);
        this.handleUpdateAddress = this.handleUpdateAddress.bind(this);

        this.handleUpdateFinish = this.handleUpdateFinish.bind(this);

        this.handleRemoveAddress = this.handleRemoveAddress.bind(this);
        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
        this.removeAddressConfirmation = this.removeAddressConfirmation.bind(this);

        this.callbackFunctions = {};

        this.callbackFunctions[addressesFormCallbackFunctions.HandleShowDisplayAddressForm] = this.handleShowDisplayAddressForm;

        this.callbackFunctions[addressesFormCallbackFunctions.HandleShowAddAddressForm] = this.handleShowAddAddressForm;
        this.callbackFunctions[addressesFormCallbackFunctions.HandleAddNewAddress] = this.handleAddNewAddress;

        this.callbackFunctions[addressesFormCallbackFunctions.HandleShowUpdateAddressForm] = this.handleShowUpdateAddressForm;
        this.callbackFunctions[addressesFormCallbackFunctions.HandleUpdateAddress] = this.handleUpdateAddress;

        this.callbackFunctions[addressesFormCallbackFunctions.HandleRemoveAddress] = this.handleRemoveAddress;

        this.addressToRemove = null;
    }

    componentWillReceiveProps(nextProps) {
        const { isSaving } = this.state;
        const { accountData, loading, isUserAccountDataLoadedSuccessful } = nextProps;

        if (isSaving && !loading) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleUpdateFinish);
        }

        if (!isSaving && !loading && isUserAccountDataLoadedSuccessful) {
            this.setState(formStateHelpers.updateAddressesFormAccountData(accountData));
        }
    }

    componentWillUnmount() {
        this.resetForm();
    }

    handleShowDisplayAddressForm() {
        this.resetForm();
        this.setState(formStateHelpers.updateAddressesFormState(addressesFormStateConstants.AddressDisplayForm));
    }

    handleShowAddAddressForm() {
        this.resetForm();
        this.setState(formStateHelpers.updateAddressesFormState(addressesFormStateConstants.AddressAddForm));
    }

    handleShowUpdateAddressForm(addressForUpdate) {
        this.resetForm();
        this.setState(formStateHelpers.updateAddressesFormState(addressesFormStateConstants.AddressUpdateForm, addressForUpdate));
    }

    displayAddressesForm() {
        const { accountData, addressForUpdate } = this.state;
        const { formData } = this.props;
        const { formState } = this.state;
        const copyOfAccountData = deepCopyObject(accountData);

        return addressesFormConstants[formState]({
            accountFormData: formData,
            accountData: copyOfAccountData,
            callbackFunctions: this.callbackFunctions,
            addressForUpdate
        });
    }

    handleAddNewAddress(newAddress) {
        const { accountData } = this.state;
        const { formData } = this.props;
        const { addAddress } = formData;
        const { actionSuccessText, callBackUrl } = addAddress;

        let copyOfAccountData = deepCopyObject(accountData);

        if (isEmpty(copyOfAccountData.addresses)) {
            newAddress.main = true;
            newAddress.shippingAddress = true;
            newAddress.billingAddress = true;
            copyOfAccountData.addresses = [];
            copyOfAccountData.addresses.push(newAddress);
            this.setState(formStateHelpers.updateSavingState(true),
                () => { this.submitAddressesData(copyOfAccountData, actionSuccessText, callBackUrl); });
            return;
        }

        copyOfAccountData = this.getUpdatedAddresses(newAddress, newAddress);
        copyOfAccountData.addresses.push(newAddress);

        this.setState(formStateHelpers.updateSavingState(true), () => {
            this.submitAddressesData(copyOfAccountData, actionSuccessText, callBackUrl);
        });
    }

    handleUpdateAddress({ addressFlaggedForUpdate, updatedAddress }) {
        const { addressForUpdate } = this.state;
        const { formData } = this.props;
        const { updateAddress } = formData;
        const { actionSuccessText, callBackUrl } = updateAddress;

        const flaggedForUpdate = isEmpty(addressFlaggedForUpdate) ? addressForUpdate : addressFlaggedForUpdate;
        if (!this.canUpdatedAddresses(flaggedForUpdate, updatedAddress)) {
            return;
        }

        const copyOfAccountData = this.getUpdatedAddresses(flaggedForUpdate, updatedAddress);

        this.setState(formStateHelpers.updateSavingState(true),
            () => { this.submitAddressesData(copyOfAccountData, actionSuccessText, callBackUrl); });
    }

    handleRemoveAddress(address) {
        const canRemoveAddress = this.canRemoveAddress(address);
        if (canRemoveAddress) {
            this.addressToRemove = address;
            this.setState(formStateHelpers.toggleKey('isConfirmationPopUpOpen'));
        }
    }

    removeAddressConfirmation() {
        const { formData } = this.props;
        const { updateAddress } = formData;
        const { accountData } = this.state;
        const { membership } = accountData;
        const { actionSuccessText, callBackUrl } = updateAddress;

        const copyOfAccountData = deepCopyObject(accountData);
        const addressToRemoveIndex = this.getAddressIndex(this.addressToRemove);

        if (accountData.addresses.length === 1 &&
            !membership.includes(MembershipTypes.OneClub) &&
            !userService.hasTicketingAccount(accountData)) {
            copyOfAccountData.addresses = [];
            this.setState(formStateHelpers.updateSavingState(true), () => { this.submitAddressesData(copyOfAccountData, actionSuccessText, callBackUrl); });
        }

        if (accountData.addresses.length > 1 &&
            !this.addressToRemove.main &&
            !this.addressToRemove.shippingAddress &&
            !this.addressToRemove.billingAddress) {
            copyOfAccountData.addresses.splice(addressToRemoveIndex, 1);
            this.setState(formStateHelpers.updateSavingState(true), () => { this.submitAddressesData(copyOfAccountData, actionSuccessText, callBackUrl); });
        }
        this.toggleConfirmationModal();
    }

    canRemoveAddress(address) {
        const { actions, formData } = this.props;
        const {
            cannotRemoveLastAddressMessage,
            cannotRemoveMainAddressMessage,
            cannotRemoveShippingAddressMessage,
            cannotRemoveBillingAddressMessage
        } = formData;
        const { accountData } = this.state;
        const { membership } = accountData;

        if (accountData.addresses.length === 1 &&
            (membership.includes(MembershipTypes.OneClub) ||
                userService.hasTicketingAccount(accountData))) {
            actions.displayUserAddressesErrorMessage([cannotRemoveLastAddressMessage || formMessageConstants.cannotRemoveLastAddress]);
            return false;
        }

        if (address.main) {
            actions.displayUserAddressesErrorMessage([cannotRemoveMainAddressMessage || formMessageConstants.cannotRemoveMainAddress]);
            return false;
        }

        if (address.shippingAddress) {
            actions.displayUserAddressesErrorMessage([cannotRemoveShippingAddressMessage || formMessageConstants.cannotRemoveShippingAddress]);
            return false;
        }

        if (address.billingAddress) {
            actions.displayUserAddressesErrorMessage([cannotRemoveBillingAddressMessage || formMessageConstants.cannotRemoveBillingAddress]);
            return false;
        }

        return true;
    }

    getUpdatedAddresses(addressFlaggedForUpdate, updatedAddress) {
        const { accountData } = this.state;
        const copyOfAccountData = deepCopyObject(accountData);
        let addressFlaggedForUpdateIndex = this.getAddressIndex(addressFlaggedForUpdate);

        if (isEmpty(copyOfAccountData.addresses)) {
            copyOfAccountData.addresses = [];
            addressFlaggedForUpdateIndex = 0;
        }

        copyOfAccountData.addresses.forEach((address, index) => {
            if (addressFlaggedForUpdateIndex !== index) {
                if (updatedAddress.main) {
                    address.main = false;
                }

                if (updatedAddress.shippingAddress) {
                    address.shippingAddress = false;
                }

                if (updatedAddress.billingAddress) {
                    address.billingAddress = false;
                }
            }
        });

        if (addressFlaggedForUpdateIndex !== -1) {
            copyOfAccountData.addresses[addressFlaggedForUpdateIndex] = updatedAddress;
        }

        return copyOfAccountData;
    }

    canUpdatedAddresses(addressFlaggedForUpdate, updatedAddress) {
        const { actions, formData } = this.props;
        const {
            cannotRemoveMainAddressMessage,
            cannotRemoveShippingAddressMessage,
            cannotRemoveBillingAddressMessage
        } = formData;

        if (!updatedAddress.main && addressFlaggedForUpdate.main) {
            actions.displayUserAddressesErrorMessage([cannotRemoveMainAddressMessage || formMessageConstants.cannotRemoveMainAddress]);
            return false;
        }

        if (!updatedAddress.shippingAddress && addressFlaggedForUpdate.shippingAddress) {
            actions.displayUserAddressesErrorMessage([cannotRemoveShippingAddressMessage || formMessageConstants.cannotRemoveShippingAddress]);
            return false;
        }

        if (!updatedAddress.billingAddress && addressFlaggedForUpdate.billingAddress) {
            actions.displayUserAddressesErrorMessage([cannotRemoveBillingAddressMessage || formMessageConstants.cannotRemoveBillingAddress]);
            return false;
        }

        return true;
    }

    getAddressIndex(addressForFind) {
        const { accountData } = this.state;
        const addressForFindJSON = JSON.stringify(addressForFind);
        let addressIndex = -1;

        if (isEmpty(accountData.addresses)) {
            return -1;
        }

        accountData.addresses.forEach((address, index) => {
            if (addressForFindJSON === JSON.stringify(address)) {
                addressIndex = index;
            }
        });

        return addressIndex;
    }

    submitAddressesData(accountData, actionSuccessText, callBackUrl) {
        const { actions } = this.props;
        const formattedActionSuccessText = actionSuccessText || formMessageConstants.updateUserAddressesSuccessText;
        actions.updateUserAddresses(accountData, formattedActionSuccessText, callBackUrl);
    }

    handleUpdateFinish() {
        const { refreshAccountPage } = this.props;
        refreshAccountPage(false);
        this.handleShowDisplayAddressForm(false);
    }

    resetForm() {
        const { actions } = this.props;
        this.setState(initialState.userAddressesFormStateConstants);
        actions.resetAddressesFormStateConstants();
    }

    toggleConfirmationModal() {
        this.setState(formStateHelpers.toggleKey('isConfirmationPopUpOpen'));
    }

    render() {
        const { isSaving, isConfirmationPopUpOpen } = this.state;
        const {
            formData,
            updateUserAddressesMessages,
            areUserAddressesUpdatedSuccessful
        } = this.props;
        const {
            formTitle,
            removeAddressInputText,
            removeAddressModalWarning
        } = formData;
        const removeAddressModalWarningSplit = getMultilineText(removeAddressModalWarning);
        return (
            <Fragment>
                <h1>{formTitle}</h1>
                <div className='category my-addresses sso-form'>
                    {isSaving ? <FormSpinner >/</FormSpinner> : null}
                    <FormMessage formRef={this.formMessageRef}
                        isSuccessMessage={areUserAddressesUpdatedSuccessful}
                        messages={updateUserAddressesMessages}></FormMessage>
                    {this.displayAddressesForm()}
                </div >
                <ConfirmationModal
                    isOpen={isConfirmationPopUpOpen === undefined ? false : isConfirmationPopUpOpen}
                    inputText={removeAddressInputText === undefined ? formMessageConstants.removeAddressConfirmationMessage : removeAddressInputText}
                    onModalClose={this.toggleConfirmationModal}
                    onApproveClick={this.removeAddressConfirmation}
                    isApproveButtonDisabled={false}
                    isApproveDanger={true}
                    onCancelClick={this.toggleConfirmationModal}
                    isCancelButtonDisabled={false}>
                    {removeAddressModalWarningSplit.map((text) => {
                        return <h2 key={uniqueId()} >{text}</h2>;
                    })}
                </ConfirmationModal>
            </Fragment >
        );
    }
}

UserAddressesForm.propTypes = {
    formData: PropTypes.object.isRequired,
    accountData: PropTypes.object.isRequired,
    refreshAccountPage: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        areUserAddressesUpdatedSuccessful: state.userAccount.areUserAddressesUpdatedSuccessful,
        isUserAccountDataLoadedSuccessful: state.userAccount.isUserAccountDataLoadedSuccessful,
        updateUserAddressesMessages: state.userAccount.updateUserAddressesMessages,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            updateUserAddresses: bindActionCreators(userAccountActions.updateUserAddresses, dispatch),
            resetAddressesFormStateConstants: bindActionCreators(userAccountActions.resetAddressesFormState, dispatch),
            displayUserAddressesErrorMessage: bindActionCreators(userAccountActions.displayUserAddressesErrorMessage, dispatch),
            resetUserDetailsFormState: bindActionCreators(userAccountActions.resetUserDetailsFormState, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserAddressesForm);
